import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const SAVE_NOTIFICATION_PREFERENCES_REQUEST =
  'app/NotificationPreferencesPage/SAVE_NOTIFICATION_PREFERENCES_REQUEST';
export const SAVE_NOTIFICATION_PREFERENCES_SUCCESS =
  'app/NotificationPreferencesPage/SAVE_NOTIFICATION_PREFERENCES_SUCCESS';
export const SAVE_NOTIFICATION_PREFERENCES_ERROR =
  'app/NotificationPreferencesPage/SAVE_NOTIFICATION_PREFERENCES_ERROR';

export const SAVE_NOTIFICATION_PREFERENCES_CLEAR =
  'app/NotificationPreferencesPage/SAVE_NOTIFICATION_PREFERENCES_CLEAR';

// ================ Reducer ================ //

const initialState = {
  saveInProgress: false,
  saveError: null,
  notificationPreferencesChanged: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SAVE_NOTIFICATION_PREFERENCES_REQUEST:
      return { ...state, saveInProgress: true, saveError: null, notificationPreferencesChanged: false };
    case SAVE_NOTIFICATION_PREFERENCES_SUCCESS:
      return { ...state, saveInProgress: false, notificationPreferencesChanged: true };
    case SAVE_NOTIFICATION_PREFERENCES_ERROR:
      return { ...state, saveInProgress: false, saveError: payload };

    case SAVE_NOTIFICATION_PREFERENCES_CLEAR:
      return { ...state, notificationPreferencesChanged: false, saveError: null };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const saveNotificationPreferencesRequest = () => ({
  type: SAVE_NOTIFICATION_PREFERENCES_REQUEST,
});
export const saveNotificationPreferencesSuccess = () => ({
  type: SAVE_NOTIFICATION_PREFERENCES_SUCCESS,
});
export const saveNotificationPreferencesError = error => ({
  type: SAVE_NOTIFICATION_PREFERENCES_ERROR,
  payload: error,
  error: true,
});

export const saveNotificationPreferencesClear = () => ({
  type: SAVE_NOTIFICATION_PREFERENCES_CLEAR,
});

// ================ Thunks ================ //

export const saveNotificationPreferences = params => (dispatch, getState, sdk) => {
  dispatch(saveNotificationPreferencesRequest());

  const {
    notificationsEnabled,
    eventCategories = {},
    industryCategories = {},
    regions = {},
    radius,
    frequency,
    quietHoursEnabled,
    quietHoursStart,
    quietHoursEnd,
  } = params;

  // Build the notification preferences object
  const notificationPreferences = {
    enabled: notificationsEnabled || false,
    eventCategories: Object.keys(eventCategories).filter(key => eventCategories[key]),
    industryCategories: Object.keys(industryCategories).filter(key => industryCategories[key]),
    regions: Object.keys(regions).filter(key => regions[key]),
    radius: radius ? parseInt(radius, 10) : 50,
    frequency: frequency || 'immediate',
    quietHours: quietHoursEnabled
      ? {
          enabled: true,
          startTime: quietHoursStart || '22:00',
          endTime: quietHoursEnd || '08:00',
        }
      : { enabled: false },
  };

  // Save to user's protected data
  return sdk.currentUser
    .updateProfile({
      protectedData: {
        notificationPreferences,
      },
    })
    .then(() => {
      dispatch(saveNotificationPreferencesSuccess());
      dispatch(fetchCurrentUser());
    })
    .catch(e => {
      dispatch(saveNotificationPreferencesError(storableError(e)));
      throw e;
    });
};

export const loadData = () => {
  // Fetch current user to get notification preferences
  return fetchCurrentUser();
};
